import {BaseService, Command, config, ensureErrorRecorder, loadApi, websocket} from "@systempiloten/react-lib";
import "material-symbols/outlined.css";
import "@phosphor-icons/web/light";
import "@phosphor-icons/web/duotone";
import "@systempiloten/react-lib/styles.css";
import ReactDOM from "react-dom/client";
import React from "react";
import "./styles/index.css";
import "./styles/sh-tokens.css"
import "./styles/buttons.css"
import "./styles/BaseComponentStyles/input.css"
import "./styles/BaseComponentStyles/select.css"
import "./styles/BaseComponentStyles/chip.css"
import "./styles/inputs.css"
import "./styles/MV.css"
import "./styles/quill.css"
import "./styles/scrollbar.css"
import "./styles/backgrounds.css"
import "./styles/cardsAndBoxes.css"
import "./styles/icons.css"
import "./styles/sh-surface-overrides.css"


import "./i18n";
import {installIntegrationNavigationGuard} from "./helpers/integrationGuard";



(() => {
  const orig = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child && child.parentNode !== this) {
      debugger;
      console.warn('removeChild mismatch', {
        intendedParent: this,
        actualParent: child.parentNode,
        isConnected: child.isConnected,
        childRoot: child?.getRootNode?.(),
        parentRoot: this?.getRootNode?.(),
        stack: new Error().stack,
      });
    }
    return orig.apply(this, arguments);
  };
})();


window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/service-worker.js");
    }
});

// Im Plugin-Kontext verhindern, dass die webview durch anchor-Klicks von der App weg-navigiert.
installIntegrationNavigationGuard();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
(async () => {
    await fetch("/configuration.json")
        .then((res) => res.json())
        .then((data) => config.load(data))
        .catch((e) => null);
    BaseService.credentials.get("default").baseUrl = config.get("backend");
    // Sammelt Fehler ab dem Start, damit eine spätere Meldung sie mitschicken kann.
    ensureErrorRecorder();
    await loadApi().catch(() => void 0);
    try {
        websocket.connect();
        websocket.cmd(Command.SyncProgressState,{})
    } catch (e) {

    }
    const {default: App} = await import("./App");
    root.render(<App/>);
})();
